import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { excludeFor, extractChanges, } from '@utils/audit.utils';
import { map } from 'rxjs/operators';
var AuditService = /** @class */ (function (_super) {
    tslib_1.__extends(AuditService, _super);
    function AuditService(http, _a) {
        var authConfig = _a.authConfig;
        var _this = _super.call(this, http, MapperService.auditMap) || this;
        _this._endpoint = authConfig.odataBaseUrl + "/AuditLogs";
        _this.reportsUrl = _this._endpoint + "/UiPath.Server.Configuration.OData.Reports";
        return _this;
    }
    AuditService.prototype.getLogDetails = function (log) {
        var _this = this;
        var id = log.id, component = log.component, action = log.action;
        return this._http
            .get(this._endpoint + "/UiPath.Server.Configuration.OData.GetAuditLogDetails(auditLogId=" + id + ")")
            .pipe(map(function (response) {
            var resultSet = _this._mapData(response, MapperService.auditLogDetails);
            var details = resultSet.data;
            details.forEach(function (_detail, index) {
                details[index] = excludeFor(component, 'All', details[index]);
                details[index] = excludeFor(component, action, details[index]);
            });
            var changes = extractChanges(details, log);
            return {
                details: details,
                changes: changes,
            };
        }));
    };
    return AuditService;
}(ODataService));
export { AuditService };
